export const ABSOLUTE_FILL_STYLE = {
  position: 'absolute',
  inset: 0,
} as const;

export const BACKDROP_STYLE = {
  ...ABSOLUTE_FILL_STYLE,
  backdropFilter: 'blur(3px)',
} as const;
